import mediator, { MediatorRequestWithResponse } from '../utilities/mediator';
import { urls } from '../utilities/dataHelpers';
import { ApiEndpoints } from 'adc-sirius-module-common';
import { SystemAbout } from '../models';

const handleGetAbout = (request: MediatorRequestWithResponse<SystemAbout>) => {
  request.response = new Promise((resolve, reject) => {
    mediator
      .request<SystemAbout>('api:invoke', {
        method: ApiEndpoints.EP_SYSTEM_ABOUT.Method,
        url: urls.api + ApiEndpoints.EP_SYSTEM_ABOUT.Path,
      })
      .then((result) => {
        if (result.status === 200) {
          resolve(result.data);
        } else {
          reject(result);
        }
      })
      .catch((err) => {
        console.error('Error fetching system about information:', err);
        reject(err);
      });
  });
};

mediator.subscribe('system:getAbout', handleGetAbout);
